module.exports = __webpack_public_path__ + "img/valtellina.dfd9418a.png";